import Axios from "axios";

const state = {
    cart: null,
    isCartPreviewVisible: false
};

const getters = {
    cart: state => state.cart,
    isCartPreviewVisible: state => state.isCartPreviewVisible
};

const mutations = {
    setCart: (state, data) => state.cart = data,
    setIsCartPreviewVisible: (state, data) => state.isCartPreviewVisible = data
};

const actions = {
    getCartInfo: async (context, data) => {
        return await Axios.post((<any>window).App.routes.Cart_GetCartInfo);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
    strict: false
};